import ModalFactory from '@/utils/modalFactory';
import ConflictsModal from './TextMerge/ConflictsModal';
/**
 * 文本合并
 */
const conflictModal = ModalFactory(ConflictsModal);
export const openConflictModal = async (options) => await conflictModal(options);
